module.exports = __webpack_public_path__ + "static/mca-audiences.86dc3421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/mca/mca-audiences.jpg
// module id = 470
// module chunks = 181542127041897